enum WidgetState {
  loading = 'loading',
  score = 'score',
  likedislike = 'likedislike',
  comment = 'comment',
  erichment = 'erichment',
  sending = 'sending',
  done = 'done',
  error = 'error',
}

export { WidgetState };
